import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import {
  LAST_CALL_END_MS,
  LAST_CALL_FRAME_AT,
  LAST_CALL_MAT_AT,
  LAST_CALL_PACK_AT,
  LAST_CALL_PORTRAIT_AT,
  LAST_CALL_SLEEVE_AT,
  lastCallOpen,
  type LastCallSnapshot,
} from '@shared/index'
import { useCollectionStore } from './collection'

export const useLastCallStore = defineStore('lastCall', () => {
  const played = ref(0)
  const packGranted = ref(false)
  const open = ref(lastCallOpen())
  const endsAt = ref(LAST_CALL_END_MS)

  const frameUnlocked = computed(
    () => import.meta.env.DEV || played.value >= LAST_CALL_FRAME_AT,
  )
  const portraitUnlocked = computed(
    () => import.meta.env.DEV || played.value >= LAST_CALL_PORTRAIT_AT,
  )
  const sleeveUnlocked = computed(
    () => import.meta.env.DEV || played.value >= LAST_CALL_SLEEVE_AT,
  )
  const matUnlocked = computed(
    () => import.meta.env.DEV || played.value >= LAST_CALL_MAT_AT,
  )

  function apply(snap: LastCallSnapshot): void {
    played.value = snap.played
    packGranted.value = snap.packGranted
    open.value = snap.open
    endsAt.value = snap.endsAt
    if (snap.packs) useCollectionStore().applyPacks(snap.packs)
  }

  return {
    played,
    packGranted,
    open,
    endsAt,
    frameUnlocked,
    portraitUnlocked,
    sleeveUnlocked,
    matUnlocked,
    packAt: LAST_CALL_PACK_AT,
    apply,
  }
})
